import { Defaults } from 'es-decorators'
import $ from 'init/jquery'
import { View } from '../components/view'
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'

/**
 * Окно браузера.
 */
@Defaults({
  el: $(window),
  events: {
    load: 'load',
    scroll: 'scroll',
    resize: 'resize',
    mouseover: 'mouseOver',
    mouseout: 'mouseOut',
    click: 'click',
  },
  EVENT_SCROLL: 'window.scroll',
  EVENT_SCROLL_THROTTLED: 'window.scroll.throttled',
  EVENT_RESIZE: 'window.resize',
  EVENT_RESIZE_DEBOUNCED: 'window.resize.debounced',
  EVENT_LOAD: 'window.load',
})
export class MainWindow extends View {
  /** @inheritDoc */
  run () {
    this.saveDimensions()
    this.debouncedResize = debounce(this.onResize, 500)
    this.debouncedScroll = debounce(this.setScrollTop, 500)
    this.throttledScroll = throttle(this.onThrottledScroll, 300, { leading: false })
  }

  /**
   * Триггерим событие load.
   */
  load () {
    this.trigger('window.load')
  }

  /**
   * Триггерим событие scroll.
   * @param {Event} e
   */
  scroll ({ currentTarget }) {
    this.trigger(this.EVENT_SCROLL, currentTarget)
    this.debouncedScroll()
    this.throttledScroll()
  }

  /**
   * Срабатывает при скролле, через равные промежутки времени
   */
  onThrottledScroll () {
    this.trigger(this.EVENT_SCROLL_THROTTLED, this.$el.scrollTop())
  }

  /**
   * Триггерим событие resize.
   * @param {Event} e
   */
  resize ({ currentTarget }) {
    this.trigger(this.EVENT_RESIZE, currentTarget)
    this.debouncedResize(currentTarget)
  }

  /**
   * Выполняется отложенно при ресайзе
   * @param {Event} e - событие ресайза
   */
  onResize ({ currentTarget }) {
    this.saveDimensions()
    this.trigger(this.EVENT_RESIZE_DEBOUNCED, currentTarget)
  }

  /** @inheritDoc */
  mouseOver ({ target }) {
    this.trigger('window.mouseover', target)
  }

  /** @inheritDoc */
  mouseOut ({ target }) {
    this.trigger('window.mouseout', target)
  }

  /** @inheritDoc */
  click ({ target }) {
    this.trigger('window.click', target)
  }

  /**
   * Запоминает текущие размеры окна.
   */
  saveDimensions () {
    this.height = this.$el.height()
    this.width = this.el.innerWidth
  }

  /**
   * Получаем ширину окна.
   * @returns {number} ширина окна.
   */
  getWidth () {
    return this.width || this.el.innerWidth
  }

  /**
   * Возвращает высоту окна
   * @returns {number} - высота окна
   */
  getHeight () {
    return this.height || this.$el.height()
  }

  /**
   * Запоминает текущую вертикальную позицию окна.
   */
  setScrollTop () {
    this.scrollTop = this.$el.scrollTop()
  }

  /**
   * Возвращает текущую вертикальную позицию окна
   * @returns {number} - позиция в px
   */
  getScrollTop () {
    return this.scrollTop
  }
}
